// Components
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import organizationFields from '../../../fields/organizationFields';
import RouteUrls from '@/app/root/enums/RouteUrls';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import Permissions from '@/app/permissions/Permissions';

export const columnsOrganizationsId = 'organizations';
export const columnsOrganizations = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsOrganizationsId, headerPackage.singleSelection),
        // Columns
        generateColumnDefByField({
            field: organizationFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ organizationId: row.original.uuid }}
                    baseUrl={RouteUrls.ORGANIZATION_DETAILS.url}
                    requiredPermissions={[Permissions.ORGANIZATION_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: organizationFields.LEGAL_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: organizationFields.BUSINESS_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: organizationFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: organizationFields.TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity nowrap
                    entity={`${organizationFields.TYPE.prefix}${cell.getValue(organizationFields.TYPE.key)}`}
                    namespace={organizationFields.TYPE.namespace}
                />
            )
        }),
        generateColumnDefByField({
            field: organizationFields.PORTS,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: organizationFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(organizationFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: organizationFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(organizationFields.UPDATED_AT.key)} />
            )
        })
    ]).filter(col => !!col);
};